import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "contents",
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

function ErrorAlert({ error, open, close }) {

  const style = useStyles().root;

  return (
    <div className={style}>
      <Snackbar open={open} autoHideDuration={6000} onClose={close}>
        <Alert onClose={close} severity="error">
          {error != null && error.message != null ? (error.message + " ") : "Ocurrió un error inesperado "}
        </Alert>
      </Snackbar>
    </div>
  );
}

function SuccessAlert({ message, open, close }) {

  const style = useStyles().root;

  return (
    <div className={style}>
      <Snackbar open={open} autoHideDuration={6000} onClose={close}>
        <Alert onClose={close} severity="success">
          {message != null ? (message + " ") : "Operación exitosa "}
        </Alert>
      </Snackbar>
    </div>
  );
}

function InfoAlert({ info, open, close }) {

  const style = useStyles().root;

  return (
    <div className={style}>
      <Snackbar open={open} autoHideDuration={6000} onClose={close}>
        <Alert onClose={close} severity="info">
          {info}
        </Alert>
      </Snackbar>
    </div>
  );
}

export { ErrorAlert, SuccessAlert, InfoAlert };
